import axios from 'axios';

const apiBaseUrl = import.meta.env.VITE_API_URL || '';

export const api = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  message: string;
}

export async function submitContactForm(data: ContactFormData) {
  try {
    const response = await api.post('/api/v1/contact', data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message =
        (error.response?.data as { message?: string } | undefined)?.message ||
        error.message;
      throw new Error(message);
    }
    throw error;
  }
}
